import i18next from 'i18next';
import { ModuleType } from 'infrastructure/enums';

export interface ModulesItem {
  id: ModuleType | null;
  name: string;
}

// TODO: i18n
export const modulesDataSource = (
  withNone = true,
  excludeModules: ModuleType[] = [],
): ModulesItem[] => {
  let dataSource: ModulesItem[] = [
    {
      id: ModuleType.RPM,
      name: i18next.t('labels.rpm'),
    },
    {
      id: ModuleType.CCM,
      name: i18next.t('labels.ccm'),
    },
    {
      id: ModuleType.APCM,
      name: i18next.t('labels.apcm'),
    },
    {
      id: ModuleType.ADMIN,
      name: i18next.t('labels.admin'),
    },
  ];

  if (excludeModules?.length) {
    dataSource = dataSource.filter((item) =>
      item.id === null ? true : !excludeModules.includes(item.id),
    );
  }

  if (withNone) {
    dataSource.unshift({
      id: null,
      name: i18next.t('labels.all'),
    });
  }

  return dataSource;
};
